export const storeBuyData = [
    {
        "id": 1,
        "image": require("../images/store/store_31.jpeg"),
        "area": "東區",
        "name": "阿粉姨布丁",
        "link": "https://silviathetraveler.com/afenyi/"
    },
    {
        "id": 2,
        "image": require("../images/store/store_32.webp"),
        "area": "南區",
        "name": "掌糕點",
        "link": "https://pingu.blog/palm-pastry/"
    },
    {
        "id": 3,
        "image": require("../images/store/store_33.jpeg"),
        "area": "東區",
        "name": "辣嘴鴨",
        "link": "https://little15.pixnet.net/blog/post/50334396"
    },
    {
        "id": 4,
        "image": require("../images/store/store_34.jpeg"),
        "area": "新化區",
        "name": "晉發米榖商店",
        "link": "https://ee025479.pixnet.net/blog/post/340086165"
    },
    {
        "id": 5,
        "image": require("../images/store/store_35.jpeg"),
        "area": "新營區",
        "name": "陳家古早味蛋糕",
        "link": "https://bear31409.pixnet.net/blog/post/355768798"
    },
    {
        "id": 6,
        "image": require("../images/store/store_36.png"),
        "area": "關廟區",
        "name": "鐵金鋼燒餅鳳梨酥",
        "link": "https://rowing2005.pixnet.net/blog/post/569747392"
    },
    {
        "id": 7,
        "image": require("../images/store/store_37.jpeg"),
        "area": "西港區",
        "name": "阿農兄芝麻工坊",
        "link": "https://pk55168.pixnet.net/blog/post/90131107"
    },
    {
        "id": 8,
        "image": require("../images/store/store_38.jpeg"),
        "area": "中西區",
        "name": "韓金婆婆日式手工豆腐酪",
        "link": "https://hchi083.pixnet.net/blog/post/364283152"
    },
    {
        "id": 9,
        "image": require("../images/store/store_39.jpeg"),
        "area": "中西區",
        "name": "皇上不上朝",
        "link": "https://evannahuang.pixnet.net/blog/post/92079301"
    },
    {
        "id": 10,
        "image": require("../images/store/store_40.jpeg"),
        "area": "安平區",
        "name": "虱目魚主題館",
        "link": "https://catandbugjoy.pixnet.net/blog/post/338137793"
    }
];
